import type { IHRDatasetInfo } from 'legacy/lut/classes/helpers/partner360/HistoricalResultsHelper'

const TNET_PATTERN = /\btnet\b/i

type TTranslate = (key: string) => unknown

/** Some category banners use a generic key, so also inspect the translated text. */
export const isTnetDisclaimer = (key: unknown, translate: TTranslate): key is string => {
  if (typeof key !== 'string' || !key.trim()) return false

  const normalizedKey = key.trim()
  return TNET_PATTERN.test(normalizedKey) || TNET_PATTERN.test(String(translate(normalizedKey)))
}

export const getTnetDisclaimerKey = (
  dataSets: readonly Pick<IHRDatasetInfo, 'Settings' | 'SummaryProgram'>[],
  translate: TTranslate
): string | undefined => {
  for (const dataSet of dataSets) {
    if (dataSet.SummaryProgram) continue

    // InfoKey is persistent category information. ActualsValueTypesInfoKey is an AVT warning.
    const key = dataSet.Settings?.InfoKey
    if (isTnetDisclaimer(key, translate)) return key.trim()
  }

  return undefined
}
